<div
	mat-dialog-content
	class="flex flex-row items-center">
	<div
		style="font-size: 1.4em; margin-right: 8px"
		class="flex-1">
		Paiement échoué.<br />Merci de réessayer avec un autre moyen de paiement.
	</div>
	<img
		src="../../../../assets/images/credit-card.png"
		width="80px"
		style="margin-left: 16px"
		alt="" />
</div>
<div
	mat-dialog-actions
	class="flex flex-row justify-end">
	<button
		mat-button
		mat-dialog-close>
		{{ "core.close" | translate }}
	</button>
</div>
